module.exports = __webpack_public_path__ + "img/thumbs-up-active.46d5562c.svg";